import React, { useState } from "react";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import SEOHelmet, {
  siteUrl,
  contactPageSchema,
  buildBreadcrumb,
} from "../components/SEOHelmet";

const Contact = () => {
  AOS.init();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    location: "",
    email: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `*New Inquiry from Baby Twinkles Photography Website*

*Name:* ${formData.name}
*Phone:* ${formData.phone}
*Location:* ${formData.location}
${formData.email ? `*Email:* ${formData.email}` : ""}
${formData.description ? `*Description:* ${formData.description}` : ""}`;

    const whatsappNumber = "918074597649";
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    
    window.open(whatsappUrl, "_blank");

    setFormData({
      name: "",
      phone: "",
      location: "",
      email: "",
      description: "",
    });
  };
  return (
    <>
      
      <SEOHelmet
        title="Contact Us | Book Your Baby Photoshoot in Hyderabad"
        description="Contact Baby Twinkles Photography in Madhapur, Hyderabad to book your newborn, baby, cake smash, maternity or family photoshoot. Call +91 8074 597 649 or email Babytwinklespic1@gmail.com. Located at Avana Apartments, Road No. 47, Ayyappa Society, Madhapur."
        keywords="contact baby photographer Hyderabad, book baby photoshoot Hyderabad, baby photography booking Hyderabad, newborn photography appointment Hyderabad, baby photographer Madhapur contact, baby studio Hyderabad phone number, book maternity shoot Hyderabad, baby photography enquiry Hyderabad"
        canonicalUrl={`${siteUrl}/contact`}
        schema={[
          contactPageSchema,
          buildBreadcrumb([
            { name: "Home", url: `${siteUrl}/` },
            { name: "Contact Us", url: `${siteUrl}/contact` },
          ]),
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            name: "Baby Twinkles Photography",
            telephone: "+918074597649",
            email: "Babytwinklespic1@gmail.com",
            url: "https://babytwinklesphotography.com",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Avana Apartments, Road No. 47, Ayyappa Society",
              addressLocality: "Madhapur",
              addressRegion: "Telangana",
              postalCode: "500081",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: "17.4490558",
              longitude: "78.3926525",
            },
            hasMap:
              "https://www.google.com/maps/place/AVANA+APARTMENTS/@17.4490558,78.3926525,17z",
            sameAs: [
              "https://www.instagram.com/baby_twinkles_photography/",
              "https://www.youtube.com/@babytwinklesphotography9753",
            ],
          },
        ]}
      />
      <div className="inner-page-banner" data-aos="fade-down">
        <div className="banner-wrapper">
          <div className="container-fluid">
            <div className="banner-main-content-wrap">
              <div className="row">
                <div className="col-12">
                  <div className="banner-content">
                    <ul className="breadcrumb-list mt-5 pt-5 d-flex justify-content-center align-items-center">
                      <li>
                        <Link to="/">Home</Link>
                      </li>
                      <li>Contact Us</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="contact-page py-3 mt-2 mb-2">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-5">
              <div className="section-title mb-50">
                <h4>Contact Us With Support Line</h4>
              </div>
              <div className="single-contact mb-4">
                <div className="title">
                  <h6>To Know More</h6>
                </div>
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.93C17.55 15.3 18.75 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45 3.45 3 4 3H7.5C8.05 3 8.5 3.45 8.5 4C8.5 5.25 8.7 6.45 9.07 7.57C9.18 7.92 9.09 8.32 8.82 8.59L6.62 10.79Z" />
                  </svg>
                </div>
                <div className="content">
                  <span>Call Now</span>
                  <h6>
                    <a href="tel:+918074597649">
                      <span className="__cf_email__">+91 8074 597 649</span>
                    </a>
                  </h6>
                </div>
              </div>
              <div className="single-contact mb-4">
                <div className="title">
                  <h6>To Know More</h6>
                </div>
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={20}
                    height={20}
                    viewBox="0 0 20 20"
                  >
                    <path d="M19.9018 8.6153C19.5412 5.99522 18.1517 3.62536 16.0393 2.02707C13.9268 0.428777 11.2643 -0.267025 8.63745 0.0927308C6.01063 0.452486 3.63468 1.83833 2.03228 3.94539C0.42988 6.05245 -0.267711 8.70813 0.0929693 11.3282C0.388972 13.4966 1.38745 15.509 2.9363 17.0589C4.48516 18.6088 6.49948 19.6113 8.67243 19.9136C9.11786 19.9713 9.56656 20.0002 10.0157 20C11.8278 20.0033 13.606 19.5101 15.1563 18.5744C15.2358 18.5318 15.3058 18.4735 15.362 18.4031C15.4182 18.3326 15.4595 18.2516 15.4833 18.1648C15.5072 18.078 15.5131 17.9872 15.5007 17.8981C15.4884 17.8089 15.458 17.7232 15.4114 17.6461C15.3648 17.569 15.303 17.5021 15.2298 17.4496C15.1565 17.397 15.0733 17.3599 14.9853 17.3403C14.8972 17.3208 14.806 17.3193 14.7173 17.336C14.6287 17.3527 14.5443 17.3871 14.4694 17.4373C12.7129 18.4904 10.6392 18.8886 8.61629 18.5613C6.59339 18.2339 4.75224 17.2022 3.4197 15.6492C2.08717 14.0962 1.34948 12.1225 1.3376 10.0784C1.32573 8.03438 2.04043 6.05225 3.35483 4.48397C4.66923 2.91568 6.49828 1.86271 8.51723 1.512C10.5362 1.16129 12.6144 1.53554 14.383 2.56829C16.1515 3.60104 17.4959 5.22548 18.1776 7.1532C18.8592 9.08092 18.8338 11.1872 18.1061 13.0981C17.9873 13.4102 17.7626 13.6709 17.4711 13.8349C17.1795 13.999 16.8396 14.056 16.5104 13.996C16.1811 13.9361 15.8833 13.763 15.6687 13.5068C15.454 13.2506 15.3362 12.9275 15.3356 12.5936V5.37867C15.3356 5.2024 15.2654 5.03336 15.1404 4.90872C15.0155 4.78408 14.846 4.71406 14.6693 4.71406C14.4925 4.71406 14.3231 4.78408 14.1981 4.90872C14.0731 5.03336 14.0029 5.2024 14.0029 5.37867V6.52578C13.2819 5.70734 12.3261 5.12961 11.265 4.8708C10.204 4.61198 9.08877 4.68456 8.0704 5.07873C7.05203 5.47289 6.17966 6.16961 5.57134 7.07458C4.96303 7.97954 4.64814 9.04908 4.66929 10.1384C4.69045 11.2278 5.04663 12.2843 5.68962 13.1651C6.33262 14.0459 7.23139 14.7084 8.2643 15.0629C9.2972 15.4175 10.4144 15.4469 11.4646 15.1473C12.5149 14.8477 13.4475 14.2335 14.1362 13.3878C14.3015 13.9385 14.6358 14.4237 15.092 14.775C15.5482 15.1263 16.1033 15.326 16.6793 15.3461C17.2553 15.3662 17.8231 15.2057 18.3028 14.887C18.7825 14.5684 19.15 14.1078 19.3535 13.5699C19.9483 11.99 20.1368 10.2866 19.9018 8.6153ZM10.0051 14.0185C9.21436 14.0185 8.4414 13.7847 7.78396 13.3465C7.12651 12.9083 6.61409 12.2856 6.3115 11.5569C6.00891 10.8283 5.92974 10.0265 6.08399 9.25296C6.23825 8.47943 6.61902 7.7689 7.17813 7.21122C7.73724 6.65354 8.4496 6.27376 9.22511 6.1199C10.0006 5.96603 10.8045 6.045 11.535 6.34681C12.2655 6.64863 12.8899 7.15973 13.3292 7.8155C13.7685 8.47126 14.0029 9.24223 14.0029 10.0309C14.0019 11.0882 13.5803 12.1018 12.8308 12.8494C12.0813 13.597 11.065 14.0175 10.0051 14.0185Z" />
                  </svg>
                </div>
                <div className="content">
                  <span>Email Now</span>
                  <h6>
                    <a href="mailto:Babytwinklespic1@gmail.com">
                      <span className="__cf_email__">
                        Babytwinklespic1@gmail.com
                      </span>
                    </a>
                  </h6>
                </div>
              </div>
              <div className="single-contact">
                <div className="title">
                  <h6>Address</h6>
                </div>
                <div className="icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={16}
                    height={20}
                    viewBox="0 0 16 20"
                  >
                    <path d="M13.1781 11.175C12.4989 12.5025 11.5785 13.825 10.6374 15.0125C9.74465 16.132 8.79006 17.2044 7.77778 18.225C6.76548 17.2044 5.81089 16.132 4.91815 15.0125C3.97704 13.825 3.05667 12.5025 2.37741 11.175C1.69037 9.83375 1.2963 8.5775 1.2963 7.5C1.2963 5.8424 1.97916 4.25269 3.19468 3.08058C4.41019 1.90848 6.05878 1.25 7.77778 1.25C9.49677 1.25 11.1454 1.90848 12.3609 3.08058C13.5764 4.25269 14.2593 5.8424 14.2593 7.5C14.2593 8.5775 13.8639 9.83375 13.1781 11.175ZM7.77778 20C7.77778 20 15.5556 12.8925 15.5556 7.5C15.5556 5.51088 14.7361 3.60322 13.2775 2.1967C11.8189 0.790176 9.84057 0 7.77778 0C5.71498 0 3.73667 0.790176 2.27806 2.1967C0.819442 3.60322 3.0738e-08 5.51088 0 7.5C0 12.8925 7.77778 20 7.77778 20Z" />
                    <path d="M7.77951 10C7.09192 10 6.43248 9.73661 5.94627 9.26777C5.46007 8.79893 5.18692 8.16304 5.18692 7.5C5.18692 6.83696 5.46007 6.20107 5.94627 5.73223C6.43248 5.26339 7.09192 5 7.77951 5C8.46711 5 9.12655 5.26339 9.61275 5.73223C10.099 6.20107 10.3721 6.83696 10.3721 7.5C10.3721 8.16304 10.099 8.79893 9.61275 9.26777C9.12655 9.73661 8.46711 10 7.77951 10ZM7.77951 11.25C8.81091 11.25 9.80007 10.8549 10.5294 10.1517C11.2587 9.44839 11.6684 8.49456 11.6684 7.5C11.6684 6.50544 11.2587 5.55161 10.5294 4.84835C9.80007 4.14509 8.81091 3.75 7.77951 3.75C6.74812 3.75 5.75896 4.14509 5.02965 4.84835C4.30035 5.55161 3.89062 6.50544 3.89062 7.5C3.89062 8.49456 4.30035 9.44839 5.02965 10.1517C5.75896 10.8549 6.74812 11.25 7.77951 11.25Z" />
                  </svg>
                </div>
                <div className="content">
                  <span>Location</span>
                  <h6>
                    <a
                      href="https://www.google.com/maps/place/AVANA+APARTMENTS/@17.4490558,78.3900776,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb911a01df1c83:0x3d207810e93b0549!8m2!3d17.4490558!4d78.3926525!16s%2Fg%2F11t1r5p7n_?entry=ttu&g_ep=EgoyMDI2MDYwMy4xIKXMDSoASAFQAw%3D%3D"
                      target="_blank"
                    >
                      Avana Apartments, Road No. 47, <br/> Ayyappa Society, Madhapur,
                      Hyderabad, Telangana 500081
                    </a>
                  </h6>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="inquiry-form">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="form-inner mb-3">
                        <label>Name*</label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required
                          placeholder="Enter Your Name"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-inner mb-3">
                        <label>Phone*</label>
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          required
                          placeholder="Enter Your Phone"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-inner mb-3">
                        <label>Location*</label>
                        <input
                          type="text"
                          name="location"
                          value={formData.location}
                          onChange={handleChange}
                          required
                          placeholder="Enter Your Location"
                        />
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="form-inner mb-3">
                        <label>
                          Email <span>(Optional)</span>
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="Enter Your Email"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="form-inner mb-3">
                        <label>Description</label>
                        <textarea
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          placeholder="Write Something..."
                        />
                      </div>
                    </div>
                    <div className="col-md-12 text-center ">
                      <div className="col-md-12">
                        <div className="form-inner">
                          <button type="submit" className="primary-btn3 w-50">
                            Submit Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div classname="col-lg-12">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30449.884878011486!2d78.35473673573098!3d17.448433649413005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9158f201b205%3A0x11bbe7be7792411b!2sMadhapur%2C%20Hyderabad%2C%20Telangana!5e0!3m2!1sen!2sin!4v1780913607572!5m2!1sen!2sin"
                height={450}
                style={{ border: "0", width: "100%" }}
                allowFullScreen
                className="rounded shadow-sm border"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
